import * as React from "react";
import styled from "../../../styled/index";
import { CS } from "../../../styles/index";
import { FaInfoCircle, FaExclamationCircle } from "react-icons/fa";
import lighten from "polished/lib/color/lighten";
import { shadeAlternate } from "../../../styled/helpers";
const Block = styled("div") `
  ${CS.flex.line_center};
  font-size: 14px;
  line-height: 1.3;
  padding: 5px 10px;
  border-radius: 3px;
`;
const Error = styled(Block) `
  color: ${({ theme }) => theme.colors.error};
  background: ${({ theme }) => lighten(0.43, theme.colors.error)};
`;
const Success = styled(Block) `
   color: ${({ theme }) => theme.colors.success};
  background: ${({ theme }) => lighten(0.43, theme.colors.success)};
`;
const Info = styled(Block) `
  color: ${({ theme }) => theme.box.text};
  background: ${({ theme }) => shadeAlternate(0.1, theme.box.background)};
`;
export const BlockInfo = (props) => (React.createElement(Info, Object.assign({}, props),
    React.createElement(FaInfoCircle, { className: "m-r-2" }),
    React.createElement("span", null, props.text || props.children)));
export const BlockError = (props) => (React.createElement(Error, Object.assign({}, props),
    React.createElement(FaExclamationCircle, { className: "m-r-2" }),
    React.createElement("span", null, props.text || props.children)));
export const BlockSuccess = (props) => (React.createElement(Success, Object.assign({}, props),
    React.createElement(FaExclamationCircle, { className: "m-r-2" }),
    React.createElement("span", null, props.text || props.children)));
//# sourceMappingURL=index.js.map